import ElementYoutube from './youtube';

const ElementVimeo = {
    ...ElementYoutube,
    ...((window.ElementVimeo || window.ElementBase))
}.extend({});

export default ElementVimeo;